/**
 * A judgment's status, in the two presentations the app uses.
 *
 * Both read from the shared registry in `lib/status`, so the table, the detail
 * panel and the filter chips can never disagree about what "Revived" looks
 * like or which tone it carries.
 */
import { Status } from '@/components/ui/Status'
import { JUDGMENT_STATUS_META, STATUS_LABELS } from '@/lib/status'
import type { JudgmentStatus } from '@/types/api'

export { STATUS_LABELS }

export interface StatusProps {
  status: JudgmentStatus
  /** The portal's own wording, when it differs from the normalised label. */
  statusText?: string
}

/** For a table: a colour chip beside the plain word. */
export function StatusDot({ status, statusText }: StatusProps) {
  return (
    <Status meta={JUDGMENT_STATUS_META[status]} variant="dot" label={statusText} />
  )
}

/** For a detail panel, where the status appears once. */
export function StatusBadge({ status, statusText }: StatusProps) {
  return (
    <Status meta={JUDGMENT_STATUS_META[status]} variant="badge" label={statusText} />
  )
}
